import clsx from 'clsx';
import { useField } from 'formik';
import React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { RadioGroup as ShadRadioGroup } from '@dashboard/components/ui/radio-group';

const Group = ({ name, children, columns = 2, className }) => {
  const [field, , helpers] = useField(name);

  return (
    <ShadRadioGroup
      value={field.value ?? ''}
      onValueChange={value => helpers.setValue(value)}
      aria-labelledby={name}
      className={clsx('grid gap-2', className, {
        'grid-cols-4': columns === 4,
        'grid-cols-3': columns === 3,
        'grid-cols-2': columns === 2,
        'grid-cols-1': columns === 1,
      })}
    >
      {children}
    </ShadRadioGroup>
  );
};

const Card = ({ value, name, children, disabled, onChange, center, className, bare }) => {
  const [field] = useField(name);
  const checked = field.value === value;

  const handleClick = async e => {
    if (disabled) return;
    if (onChange) {
      const shouldProceed = (await onChange(value)) ?? true;
      if (!shouldProceed) {
        e.preventDefault();
      }
    }
  };

  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-card"
      value={value}
      disabled={disabled}
      onClick={handleClick}
      className={clsx(
        'relative rounded-md px-3 py-2 text-sm font-medium block w-full',
        center ? 'text-center' : 'text-left',
        'border border-input transition-colors outline-none cursor-pointer',
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'data-[state=checked]:border-primary',
        'data-[state=unchecked]:hover:bg-accent/50',
        {
          'cursor-not-allowed opacity-50': disabled,
        },
        className,
      )}
    >
      {bare ? children : <div className={clsx('flex-1', center ? 'px-6' : 'pr-6')}>{children}</div>}
      <span
        className={clsx(
          'absolute right-2 top-2 flex size-4 items-center justify-center rounded-full border transition-colors',
          checked ? 'border-primary' : 'border-input',
        )}
      >
        <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
          <span className="size-2 rounded-full bg-primary" />
        </RadioGroupPrimitive.Indicator>
      </span>
    </RadioGroupPrimitive.Item>
  );
};

const Label = ({ children }) => {
  return <div className="font-medium">{children}</div>;
};

const LabelDescription = ({ children }) => {
  return <div className="text-xs font-normal text-muted-foreground">{children}</div>;
};

const RadioCard = {
  Group,
  Label,
  LabelDescription,
  Card,
};

export default RadioCard;
